<template>
  <a-modal
    :confirmLoading='confirmLoading'
    :title='title'
    :visible='visible'
    :width='800'
    cancelText='关闭'
    :footer="null"
    @cancel='handleCancel'>
    <a-table :columns='columns' :dataSource='dataSource' :pagination='false'  rowKey='id' size='small'>
      <span slot="action" slot-scope="text,record">
          <a @click="editPatientView(record)">{{record.patientView==='1'?'停用展示':'启用展示'}}</a>
      </span>

    </a-table>
  </a-modal>
</template>

<script>
import { postAction } from '@api/manage'

export default {
  name: 'ShowScalesModel',
  data() {
    return {
      title: '结论展示',
      visible: false,
      confirmLoading: false,
      url: {
        // add: "/admin/help/add",
        // edit: "/admin/help/edit",
      },
      dataSource: [],
    }
  },
  computed: {
    columns() {
      return [
        {
          title: '序号',
          align: 'center',
          width: 80,
          customRender: (text, record, index) => (index + 1)
        },
        {
          title: '量表名称',
          dataIndex:'name',
          align: 'center',
          ellipsis: true,
        },
        {
          title: '展示状态',
          dataIndex:'patientView',
          customRender: (text, record, index) => text==='1'?'是':'否' ,
          align: 'center',
          width: 120,
        },
        {
          title: '操作',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        }
      ]
    }
  },
  created() {
  },
  methods: {
    edit(dataSource) {
      this.dataSource =JSON.parse(JSON.stringify(dataSource))
      this.visible = true
    },
    editPatientView(record){
      postAction('/project/projectForm/editPatientView',{id:record.id}).then(res=>{
        if(res.success){
          this.$message.success(res.message)
          this.$set(record,'patientView',res.result)
          this.$emit('ok')
        }
      })
    },
    handleCancel() {
      this.visible = false
    },
  }
}
</script>

<style scoped>

</style>
